<template>
  <v-app >
    <!-- App Bar -->
    <v-app-bar color="primary" dark elevation="2" app>
      <v-btn icon @click="$router.push({ name: 'PortalBusca' })">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="font-weight-bold">
        Ticket {{ ticketId }}
      </v-toolbar-title>
      <v-spacer />
      <img
        src="../assets/logo-obrigado.png"
        style="width: 20%; max-width: 100px"
      />
    </v-app-bar>

    <!-- Overlay de carregamento -->
    <v-overlay :value="carregando" z-index="200">
      <v-progress-circular indeterminate size="48" color="primary" />
    </v-overlay>

    <!-- Erro -->
    <v-main v-if="erro && !carregando">
      <div
        class="d-flex flex-column align-center justify-center"
        style="height: calc(100vh - 64px); "
      >
        <v-icon size="64" color="grey lighten-1">
          {{ iconeErro }}
        </v-icon>
        <h3 class="mt-4 grey--text">{{ mensagemErro || 'Ticket não encontrado' }}</h3>
        <p class="grey--text text-center px-8">
          {{ subtituloErro }}
        </p>
        <v-btn
          color="primary"
          class="mt-4"
          @click="$router.push({ name: 'PortalBusca' })"
        >
          Voltar à busca
        </v-btn>
      </div>
    </v-main>

    <!-- Conteúdo principal -->
    <v-main v-else-if="ticket">
      <!-- DESKTOP: sidebar + chat lado a lado -->
      <v-row
        no-gutters
        style="height: calc(100vh - 64px); "
        class="hidden-sm-and-down"
      >
        <!-- Sidebar (desktop) -->
        <v-col
          cols="3"
          class="d-flex flex-column blue-grey lighten-5"
          style="height: 100%; overflow-y: auto"
        >
          <div class="pa-4" style="max-height: calc(100vh - 64px);overflow:hidden;">
            <!-- Info do ticket -->
            <div class=" mb-4">
              <div
                class="text-caption text--disabled  mb-1"
                style="opacity: 0.7"
              >
                NÚMERO
              </div>
              <div
                class="text-h6 font-weight-bold d-flex align-center justify-space-between"
              >
                {{ ticketId }}

                <v-chip
                  small
                  color="white"
                  :text-color="corStatus"
                  class="mt-1"
                >
                  {{ itemsStatus[ticket.status || ""] }}
                </v-chip>
              </div>
              <p class="body-2 mt-3">
                {{ ticket.tipoSuporte }}
              </p>
              <div
                class="body-2 mt-3 d-flex flex-wrap align-center justify-space-between"
              >
                {{ ticket.nSerie }}

                <v-chip
                  x-small
                  color="white"
                  :text-color="corStatus"
                  class="mt-1"
                >
                  {{ formataData(ticket.dataInicioOperacao) }}
                </v-chip>
              </div>
              <p class="body-2 mt-3" style="opacity: 0.85">
                {{ ticket.descricao }}
              </p>
            </div>

            <v-divider class="white mb-2" style="opacity: 0.2" />

            <!-- Arquivos no sidebar (desktop) -->
            <div
              class=" mb-2 text-caption font-weight-bold"
              style="opacity: 0.7; letter-spacing: 0.08em"
            >
              ARQUIVOS DO TICKET
            </div>
            <!-- Componente reutilizaável com busca S3 -->
            <div style="background: rgba(255,255,255,0.06); border-radius: 8px; margin-bottom: 8px;">
              <ticket-arquivos ref="arquivos" :ticket-id="ticketId" dark-mode />
            </div>
          </div>
        </v-col>

        <!-- Chat (desktop) -->
        <v-col
          class="d-flex flex-column"
          style="height: 100%; overflow: hidden"
        >
          <!-- Subtítulo -->
          <div class="pa-3 white elevation-1">
            <span class="body-2 grey--text">{{
              ticket.descricaoResumida ||
              ticket.obra ||
              "Detalhes do atendimento"
            }}</span>
          </div>
          <ticket-chat @nova-interacao="atualizaArquivos" :ticket="ticket" :ticket-id="ticketId" :is-progali="isProgali" style="flex: 1; overflow: hidden" />
        </v-col>
      </v-row>

      <!-- MOBILE: tabs Mensagens | Arquivos -->
      <div
        class="hidden-md-and-up"
        style="
          width: 100vw;
          display: flex;
          flex-direction: column;
        "
      >
        <!-- Subtítulo do ticket -->
        <div 
          class="pa-2 white elevation-1 d-flex flex-column align-start" 
          style="max-height: 130px; overflow-y: auto; flex-shrink: 0;"
        >
          <span class="caption font-weight-bold mb-1">{{ itemsStatus[ticket.status || ""] }}</span>
          <span class="grey--text body-2">{{ ticket.descricao }}</span>
        </div>
        <v-tabs
          v-model="tabAtiva"
          color="primary"
          grow
          slider-color="primary"
          background-color="white"
          class="elevation-1 flex-shrink-0 flex-grow-0"
          style="flex: 0 0 auto;"
        >
          <v-tab>
            <v-icon left small>mdi-chat-outline</v-icon>
            Mensagens
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-folder-outline</v-icon>
            Arquivos
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabAtiva" style="flex: 1; overflow: hidden" destroy-on-close>
          <v-tab-item style="height: 100%; overflow: hidden">
            <ticket-chat  :ticket="ticket" :ticket-id="ticketId" :is-progali="isProgali" style="height: 100%" />
          </v-tab-item>
          <v-tab-item style="height: 100%; overflow-y: auto">
            <ticket-arquivos :ticket-id="ticketId" />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import API from "@/api/API";
import TicketChat from "@/components/portal/TicketChat.vue";
import TicketArquivos from "@/components/portal/TicketArquivos.vue";
import jwt from "jsonwebtoken";

export default {
  name: "PortalTicket",
  components: { TicketChat, TicketArquivos },
  data: () => ({
    ticket: null,
    carregando: true,
    erro: false,
    mensagemErro: "",
    tabAtiva: 0,
    isProgali: false,
    ultimaAtividade: Date.now(),
    refreshTimer: null,
    itemsStatus: {
      "analise-tecnica": "Em análise técnica",
      evidencias: "Aguardando evidências",
      visita: "Aguardando visita em campo",
      andamento: "Em andamento",
      concluido: "Concluído",
      "": "-",
    },
  }),
  computed: {
    ticketId() {
      return this.$route.params.id;
    },
    corStatus() {
      const s = (this.ticket?.status || "").toLowerCase();
      if (s.includes("finaliz") || s.includes("concluí")) return "#22c55e";
      if (s.includes("andamento") || s.includes("aberto")) return "#FF6101";
      return "#6b7280";
    },
    iconeErro() {
      if (this.mensagemErro === 'Acesso Negado') return 'mdi-shield-lock-outline';
      if (this.mensagemErro === 'Sessão Encerrada') return 'mdi-clock-alert-outline';
      return 'mdi-ticket-outline';
    },
    subtituloErro() {
      if (this.mensagemErro === 'Acesso Negado') return 'O email informado não possui acesso a este ticket.';
      if (this.mensagemErro === 'Sessão Encerrada') return 'Sua sessão foi encerrada por inatividade. Acesse o link novamente para continuar.';
      return 'Verifique o ID e tente novamente.';
    },
  },
  async created() {
    await this.carregarTicket();
    console.log("Ticket carregado:", this.ticket);
    if (this.ticket && !this.erro) {
      this.monitorarAtividadeUsuario();
    }
  },
  beforeDestroy() {
    this.pararMonitorAtividade();
  },
  methods: {
    atualizaArquivos() {
      this.$refs.arquivos?.buscarArquivos();
    },
    registrarAtividade() {
      this.ultimaAtividade = Date.now();
    },
    monitorarAtividadeUsuario() {
      const EVENTOS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      EVENTOS.forEach(ev =>
      window.addEventListener(ev, this.registrarAtividade, { passive: true })
    );
      const REFRESH_INTERVAL_MS = 9 * 60 * 1000;
      this.refreshTimer = setInterval(this.renovarToken, REFRESH_INTERVAL_MS);
    },

    pararMonitorAtividade() {
      const EVENTOS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      EVENTOS.forEach(ev =>
        window.removeEventListener(ev, this.registrarAtividade)
      );
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    async renovarToken() {
      const INATIVIDADE_MS = 9 * 59 * 1000; //Pouco menos que o tempo de expiração do token
      const inativo = (Date.now() - this.ultimaAtividade) > INATIVIDADE_MS;

      if (inativo) {
        console.error('Usuário inativo. Encerrando sessão.');
        this.pararMonitorAtividade();
        this.ticket = null;
        this.erro = true;
        this.mensagemErro = 'Sessão Encerrada';
        return;
      }

      try {
        await API.refreshTokenPortal(this.ticketId);
      } catch (e) {
        console.log('Erro ao renovar token.', e);
        this.pararMonitorAtividade();
        this.ticket = null;
        this.mensagemErro = 'Sessão Encerrada';
        this.erro = true;
      }
    },

    async carregarTicket() {
      this.carregando = true;
      this.erro = false;
      try {
        this.ticket = await API.buscarTicketPortal(this.ticketId);
        console.log("Ticket carregado:", this.ticket);
        if (!this.ticket) throw new Error("Ticket não encontrado");
        
        const emailUsuario = (sessionStorage.getItem("emailUsuario") || "").trim().toLowerCase();
        const token = (sessionStorage.getItem("token") || "")
        this.isProgali = jwt.decode(token)?.origem === "progali";
        if(!this.isProgali) {
          console.log("Email de acesso via Progali:", emailUsuario);
        const emailsPermitidos = [
          this.ticket.email,
          this.ticket.emailSecundario
        ];
        if (this.ticket.emailAcompanhamento && this.ticket.emailAcompanhamento.length > 0) {
          emailsPermitidos.push(...this.ticket.emailAcompanhamento);
        }
        console.log("Emails permitidos:", emailsPermitidos);
        console.log("emailUsuario:", emailUsuario);
        const temAcesso = emailsPermitidos.some(email => 
          email && email.trim().toLowerCase() === emailUsuario
        );
        
        if (!emailUsuario || !temAcesso) {
          throw new Error("Sem acesso");
          }
        }
        
      } catch (e) {
        console.log(e);
        this.erro = true;
        this.mensagemErro = e.message === "Sem acesso" ? "Acesso Negado" : "Ticket não encontrado";
      } finally {
        this.carregando = false;
      }
    },
    iconeArquivo(arquivo) {
      const nome = (arquivo.nome || arquivo.name || "").toLowerCase();
      if (/\.(jpg|jpeg|png|gif|webp|svg)$/.test(nome)) return "mdi-file-image";
      if (/\.pdf$/.test(nome)) return "mdi-file-pdf-box";
      if (/\.(doc|docx)$/.test(nome)) return "mdi-file-word";
      if (/\.(xls|xlsx)$/.test(nome)) return "mdi-file-excel";
      return "mdi-file";
    },
    nomeArquivo(arquivo) {
      return (
        arquivo.nome ||
        arquivo.name ||
        arquivo.key?.split("/").pop() ||
        "Arquivo"
      );
    },
    formataData(data) {
      return new Date(data).toLocaleString("pt-BR", {
        dateStyle: "short",
      });
    },
  },
};
</script>

<style scoped>
/* Remove v-app background override so the primary sidebar shows correctly */
::v-deep .v-application--wrap {
  min-height: 100vh;
}
</style>
